<template>
	<div>
		<div>
			<vue-slider v-model="value" v-bind="sliderObj" :show="show"></vue-slider>
		</div>
	</div>
</template>

<script>
import vueSlider from 'vue-slider-component';
export default {

  name: 'transparency-slider',
  props: {
  	show: {
  		type: Boolean,
  		default: false
  	},
  	initValue: {
  		type: Number,
  		default: 0
  	}
  },
  components: {
  	vueSlider
  },
  watch: {
  	value (val) {
  		this.$emit('set-opacity', val)
  	}
  },
  data() {
    return {
    	value: 0,
      sliderObj:{
        tooltipDir:"top",
        tooltip:"hover",
        min:0,
        max:100,
        startAnimation:false
      }
    };
  },
  mounted () {
  	if (this.value != this.initValue) {
  		this.value = this.initValue
  	}
  },
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// resources/js/map/MapComponents/Legend/TransparencySlider.vue